import { z } from 'zod';

import { ContactPersonEntrySchema } from './contact-person.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { PolymerSubgroupEntrySchema } from './polymer-subgroup.validator';

export const BrandSubgroupEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    polymerSubgroup: z.array(PolymerSubgroupEntrySchema),
    productManager: ContactPersonEntrySchema.optional().nullable(),
    contentManager: ContactPersonEntrySchema.optional().nullable(),
    nrOfActiveProducts: z.number().int().optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});
